module.exports = __webpack_public_path__ + "media/images/sp/visit_reservations_enpou/flow_03-4b45f1bdd7b91ca483f934208a4bfed5.jpg";